import { useState, type FormEvent } from 'react';
import { sendContactForm, type ContactFormData } from '../api/contact';
import { Analytics } from '../utils/analytics';

export default function ContactCTA() {
  const [form, setForm] = useState<ContactFormData>({
    name: '', email: '', phone: '', company: '', subject: 'konzultace', message: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState<{ type: 'success' | 'error'; msg: string } | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    try {
      const res = await sendContactForm(form);
      if (res.success) {
        setStatus({ type: 'success', msg: 'Děkujeme! Ozveme se vám do 24 hodin.' });
        setForm({ name: '', email: '', phone: '', company: '', subject: 'konzultace', message: '' });
        Analytics.contactFormSubmit('landing-cta');
      } else {
        setStatus({ type: 'error', msg: res.message || 'Něco se pokazilo. Zkuste to znovu.' });
      }
    } catch {
      setStatus({ type: 'error', msg: 'Chyba připojení. Zavolejte nám přímo.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="final-cta" id="cta">
      <div className="container">
        <div className="final-cta-inner">
          <div className="final-cta-text">
            <h2>Zítra ráno můžete zase<br />přepisovat doklady ručně.<br />Nebo nám <span className="accent">zavoláte</span>.</h2>
            <p>30minutová konzultace zdarma. Žádný závazek. Jen si probereme, jestli vám SyncroX dává smysl.</p>
            <a href="tel:+420773751263" className="final-cta-phone">&#128222; +420 773 751 263</a>
            <div className="final-cta-note">Odpovídáme do 24 hodin. Obvykle rychleji.</div>
          </div>

          <form className="contact-form-card" onSubmit={handleSubmit}>
            <h3>Napište nám</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Jméno *</label>
                <input className="form-input" required value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Jan Novák" />
              </div>
              <div className="form-group">
                <label>E-mail *</label>
                <input className="form-input" type="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="jan@firma.cz" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Telefon</label>
                <input className="form-input" type="tel" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} placeholder="+420..." />
              </div>
              <div className="form-group">
                <label>Firma</label>
                <input className="form-input" value={form.company} onChange={e => setForm(f => ({ ...f, company: e.target.value }))} placeholder="Firma s.r.o." />
              </div>
            </div>
            <div className="form-group">
              <label>Téma</label>
              <select className="form-select form-input" value={form.subject} onChange={e => setForm(f => ({ ...f, subject: e.target.value }))}>
                <option value="konzultace">Bezplatná konzultace</option>
                <option value="integrace">Integrace na míru</option>
                <option value="cenik">Cenová kalkulace</option>
                <option value="podpora">Technická podpora</option>
                <option value="jine">Jiné</option>
              </select>
            </div>
            <div className="form-group">
              <label>Zpráva</label>
              <textarea className="form-textarea" rows={4} required minLength={10} value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} placeholder="Jaké systémy používáte? Co potřebujete propojit?" />
            </div>
            <button type="submit" className="form-submit" disabled={submitting}>
              {submitting ? 'Odesílám...' : 'Odeslat zprávu'}
            </button>
            {status && <div className={`form-status ${status.type}`}>{status.msg}</div>}
          </form>
        </div>
      </div>
    </section>
  );
}
